import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { GapBetweenIcons } from '../styles';
import Button from '../../../../../../../../shared/basic/Button';
import IconPlay from '../../../../../../../../shared/icon/IconPlay';
import IconGoogle from '../../../../../../../../shared/icon/IconGoogle';
import { openPlaylistLink } from '../../../../../../../../shared/helper/openPlaylistLink';

const ButtonGoogle = ({ id, isLoading, bgColor, color, ...props }) => {
  const handleClick = () => {
    if (id) openPlaylistLink('googleAssistant', id);
  };
  return (
    <Button
      tip="Open playlist in Google Assistant"
      disabled={!id}
      onClick={handleClick}
      bgColor={bgColor || '#dae7fe'}
      color={isLoading ? 'transparent' : color || '#4c8bf5'}
      {...props}
    >
      <GapBetweenIcons><IconPlay /><IconGoogle /></GapBetweenIcons>
    </Button>
  );
}

ButtonGoogle.propTypes = {
  id: PropTypes.any,
  isLoading: PropTypes.bool,
};

ButtonGoogle.defaultProps = {
  id: null,
  isLoading: false,
};

export default memo(ButtonGoogle);
